// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SignalFilledSvg from "@ant-design/icons-svg/es/asn/SignalFilled";
import AntdIcon from '../components/AntdIcon';

var SignalFilled = function SignalFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SignalFilledSvg
  }));
};

SignalFilled.displayName = 'SignalFilled';
export default React.forwardRef(SignalFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SignalFilled.js
// module id = 1801
// module chunks = 0